<template>
  <div style="margin-bottom:60px">
    <div class="bigbgi">
      <div class="zwydt">展位预定</div>
    </div>
    <div style="width:50%;display:flex;align-items: center;margin:0 auto">
      <!-- <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="公司名称:">
          <el-input v-model="form.gsname"></el-input>
        </el-form-item>
        <el-form-item label="申请面积:">
          <el-input v-model="form.gsmj"></el-input>
        </el-form-item>
        <el-form-item label="联系人:">
          <el-input v-model="form.lxrname"></el-input>
        </el-form-item>
        <el-form-item label="联系方式:">
          <el-input v-model="form.lxfs"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input type="textarea" v-model="form.bz"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:30px">

          <el-button style="width:100%;height:50px;font-size:18px" type="success" @click="btnclick">确定</el-button>
        </el-form-item>
      </el-form> -->
      <img style="margin:0 auto" src="../../assets/index/zwydimg.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {}
    }
  },
  methods: {
    btnclick () {
      this.form = {}
      this.$message('提交成功')
    }
  }
}
</script>

<style scoped>
.bigbgi {
  background-image: url('../../assets/index/ban-ls.jpg'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 400px; /* 元素高度 */
  width: 100%;
  margin-bottom: 20px;
  color: #fff;
  font-size: 32px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.zwydt {
  text-align: center;
  width: 80%;
  margin: 0 auto;
  background-color: rgba(61, 155, 53, 0.8);
  height: 60px;
  line-height: 56px;
}
/deep/ .el-form-item__label {
  font-size: 18px !important;
  width: 120px !important;
}
/deep/ .el-form-item__content {
  margin-left: 150px !important ;
}
</style>



// WEBPACK FOOTER //
// src/components/caidan/zsdj.vue